// The Lista/Kalender segmented control shared by the patient flow panel and the
// flow builder, so the two stay visually + behaviorally identical.
export type FlowView = "list" | "calendar";

export function ViewToggle({
  value,
  onChange,
}: {
  value: FlowView;
  onChange: (next: FlowView) => void;
}) {
  return (
    <div className="flex rounded-md border border-surfaceMuted overflow-hidden text-xs">
      {(["list", "calendar"] as const).map((v) => (
        <button
          key={v}
          type="button"
          onClick={() => onChange(v)}
          aria-pressed={value === v}
          className={`px-sm py-xs ${
            value === v
              ? "bg-brand text-white"
              : "bg-surface text-textSecondary hover:text-textPrimary"
          }`}
        >
          {v === "list" ? "Lista" : "Kalender"}
        </button>
      ))}
    </div>
  );
}
